import {Organization} from '../../_models/Organization';
import {Subscription} from 'rxjs';
import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {Router, RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {AuthService} from '@auth0/auth0-angular';
import {AuthButtonComponent} from 'src/app/auth/auth-button/auth-button.component';
import {AppAuthService} from 'src/app/_services/app-auth.service';
import {OrganizationDto} from 'src/app/_dtos/organizations/organization-dto';
import {OrganizationService} from 'src/app/_services/organization.service';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import { SidenavService } from 'src/app/_services/sidenav.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: true,
    imports: [MatToolbarModule, MatIconModule, RouterModule, CommonModule, MatMenuModule, MatButtonModule, AuthButtonComponent],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Output() sidenavToggle = new EventEmitter<void>();
    currentOrg: OrganizationDto;
    organizationList: OrganizationDto[];
    private _storesSub: Subscription;
    private _stores: Organization[];
    userOrganization: OrganizationDto[];

    constructor(
        private _router: Router,
        private _orgService: OrganizationService,
        public appAuthService: AppAuthService,
        public auth: AuthService,
        private _sideNavService: SidenavService
    ) {
        toObservable(this.appAuthService.isLoggedIn)
            .pipe(takeUntilDestroyed())
            .subscribe((isLoggedIn) => {
                if (isLoggedIn) {
                    this.userOrganization = this.appAuthService.getUserOrganizations();

                    if (this._orgService.stores?.length) {
                        this._orgService.storesSub.next(this._orgService.stores);
                    } else {
                        this._orgService.getStores();
                    }
                }
            });
    }

    async ngOnInit() {
        this.currentOrg = this.appAuthService.currentOrganization;

        this._storesSub = this._orgService.storesSub
            .subscribe((stores: Organization[]) => {
                this._stores = stores;

                this.filterOrganizationList();
            });
    }

    ngOnDestroy() {
        this._storesSub.unsubscribe();
    }

    onToggleSidenav() {
        this.sidenavToggle.emit();
    }

    selectOrganization(organization: OrganizationDto) {
        this.appAuthService.setCurrentOrganization(organization);
        this.currentOrg = this.appAuthService.currentOrganization;
        this._sideNavService.updateLinks([]);
    }

    logout() {
        this.appAuthService.destroy();
        this.auth.logout({logoutParams: {returnTo: window.location.origin}});
    }

    signUp() {
        this._router.navigate(['/signup']);
    }

    private filterOrganizationList() {
        if (this.appAuthService.isSuperUser())
        {
            this.organizationList = this._stores;
        }
        else {
            this.organizationList = this._stores
                .filter(org => this.userOrganization
                    .some(userOrg => userOrg.name.toLowerCase() === org.name.toLowerCase()));
        }
    }
}
